import { MailTemplateData, MailTemplateModel } from 'models/Mailings';
import { ApiBase } from 'utils/api';
import { objectToFormData } from 'utils/common';


export default class MailingApi {
    private base: ApiBase;

    constructor(base: ApiBase) {
        this.base = base;
    };

    templates = () => this.base.axios
        .get('/api/mailings')
        .then(res => res.data);

    getTemplate = (id: number) => this.base.axios
        .get(`/api/mailings/${id}`)
        .then(res => res.data);

    createTemplate = (data: MailTemplateData) => this.base.axios
        .post('/api/mailings', data)
        .then(res => res.data);

    updateTemplate = (data: MailTemplateModel) => this.base.axios
        .put(`/api/mailings/${data.id}`, data)
        .then(res => res.data);

    deleteTemplate = (id: number) => this.base.axios
        .delete(`/api/mailings/${id}`);

    send = (subject: string, content: string, attachments: File[], type: string, ids: number[], preview: boolean = false) => {
        const act = preview ? 'preview' : 'send';

        return this.base.axios.post(`/api/mailings/${act}`,
            objectToFormData({
                subject,
                content,
                attachments,
                type,
                ids,
            }),
            {headers: {'Content-Type': 'multipart/form-data'}})
            .then(res => res.data);
    };
}
